import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { Tooltip } from "@progress/kendo-react-tooltip";
import isFunction from "lodash-es/isFunction";
import * as React from "react";
import { If, Then } from "react-if";
import TitleFilter from "@/helpers/title_filter";
import DialogIcon from "./dialog.svg?react";

const FormSelectItemRender = (
  li: React.ReactElement<HTMLLIElement>,
  itemProps: ListItemProps & {
    descriptionField?: string;
    imageRender?: (dataItem: ListItemProps["dataItem"]) => React.ReactNode;
  },
) => {
  const dataItem = itemProps.dataItem;
  const title = dataItem?.[itemProps.textField || "name"];
  const description = itemProps.descriptionField
    ? dataItem?.[itemProps.descriptionField]
    : undefined;
  const optionInfoText = dataItem?.optionInfoText;
  const hasDialog = dataItem.openDialog;

  let props = { ...li.props };

  if (dataItem.disabled || dataItem.checkAllDisabled) {
    props = {
      ...props,
      className: "k-list-item k-disabled",
    };
  }

  if (title || optionInfoText || hasDialog) {
    props = {
      ...props,
      style: {
        ...props.style,
        display: "block",
      },
    };

    return (
      <Tooltip
        anchorElement="target"
        position="top"
        filter={TitleFilter}
        style={{ maxWidth: "18.75rem", wordBreak: "break-word" }}
      >
        {React.cloneElement(
          li,
          props,
          <span className="k-d-flex k-d-flex-row k-d-flex-space-between k-d-flex-align-center">
            <If condition={isFunction(itemProps.imageRender)}>
              <Then>{itemProps.imageRender?.(dataItem)}</Then>
            </If>
            <span
              className="longTitleOnly kendo-custom-tooltip"
              title={title}
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontWeight: description ? 700 : "normal",
                flexBasis: "100%",
              }}
            >
              {title}
            </span>
            <If condition={hasDialog}>
              <Then>
                <DialogIcon />
              </Then>
            </If>
            <If condition={optionInfoText}>
              <Then>
                <span
                  title={optionInfoText}
                  className="k-icon k-font-icon k-i-info info-icon kendo-custom-tooltip"
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginLeft: "auto",
                  }}
                />
              </Then>
            </If>
            <If condition={!!description}>
              <Then>
                <span className="description">{description}</span>
              </Then>
            </If>
          </span>,
        )}
      </Tooltip>
    );
  } else {
    return React.cloneElement(li, props, <>{title}</>);
  }
};

export default FormSelectItemRender;
